import React from 'react';
import {
  IconCoinMoneyStroked,
  IconPulse,
  IconLayers,
  IconBolt,
  IconSaveStroked,
  IconStopwatchStroked,
} from '@douyinfe/semi-icons';
import { formatCompact, formatFull } from '../helpers/usage';

function formatCostSmart(cost) {
  return cost.toFixed(2);
}

const Tile = ({ icon, label, value, sub, title }) => (
  <div className="stat-tile" title={title}>
    <div className="stat-tile-label">
      <span className="tile-icon">{icon}</span>
      {label}
    </div>
    <div className="stat-tile-value">{value}</div>
    {sub && <div className="stat-tile-sub">{sub}</div>}
  </div>
);

// KPI 瓦片行：总消费 / 请求数 / 总tokens / 缓存读 / 缓存写 / 平均用时
const StatTiles = ({ totals, todayUsd }) => {
  if (!totals) return null;

  // Anthropic 语义下另行计入总量的缓存 tokens（OpenAI 式缓存已含在提示里，不在此列）
  const cacheExtra = totals.totalTokens - totals.promptTokens - totals.completionTokens;

  const cacheWriteSub =
    totals.cacheWrite5m > 0 || totals.cacheWrite1h > 0
      ? `5m ${formatCompact(totals.cacheWrite5m)} · 1h ${formatCompact(totals.cacheWrite1h)}`
      : totals.cacheWrite > 0
        ? '未细分时长'
        : '本期无缓存写入';

  return (
    <div className="tiles-grid">
      <Tile
        icon={<IconCoinMoneyStroked size="small" />}
        label="总消费"
        value={formatCostSmart(totals.usd)}
        sub={`今日 ${formatCostSmart(todayUsd || 0)}`}
        title={`精确值：${totals.usd.toFixed(6)}`}
      />
      <Tile
        icon={<IconPulse size="small" />}
        label="请求次数"
        value={formatCompact(totals.requests)}
        sub={`流式占比 ${(totals.streamRate * 100).toFixed(0)}%`}
        title={`共 ${formatFull(totals.requests)} 次`}
      />
      <Tile
        icon={<IconLayers size="small" />}
        label="总 Tokens"
        value={formatCompact(totals.totalTokens)}
        sub={
          `提示 ${formatCompact(totals.promptTokens)} · 补全 ${formatCompact(totals.completionTokens)}` +
          (cacheExtra > 0 ? ` · 缓存 ${formatCompact(cacheExtra)}` : '')
        }
        title={`共 ${formatFull(totals.totalTokens)} tokens`}
      />
      <Tile
        icon={<IconBolt size="small" />}
        label="缓存读取"
        value={formatCompact(totals.cacheRead)}
        sub={`占输入的 ${(totals.cacheHitRate * 100).toFixed(1)}%`}
        title={`共 ${formatFull(totals.cacheRead)} tokens 命中缓存`}
      />
      <Tile
        icon={<IconSaveStroked size="small" />}
        label="缓存写入"
        value={formatCompact(totals.cacheWrite)}
        sub={cacheWriteSub}
        title={`共 ${formatFull(totals.cacheWrite)} tokens 写入缓存`}
      />
      <Tile
        icon={<IconStopwatchStroked size="small" />}
        label="平均用时"
        value={`${totals.avgUseTime.toFixed(1)}s`}
        sub="平均每次请求"
      />
    </div>
  );
};

export default StatTiles;
